import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Input, Modal } from 'antd';
import { updateWorkspace } from '../../services/WorkspacesService';

/** Rename a workspace (its owner). */
export default function RenameWorkspace({ open, workspace, onClose, onSaved }) {
  const [name, setName] = useState(workspace.name);
  const [error, setError] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { if (open) { setName(workspace.name); setError(null); } }, [open, workspace.name]);

  const save = async() => {
    setSaving(true);
    setError(null);
    try {
      await updateWorkspace(workspace.id, { name: name.trim() });
      onSaved();
      onClose();
    } catch (failed) {
      setError(failed.message);
    } finally {
      setSaving(false);
    }
  };
  return (
    <Modal
      cancelText="Cancel"
      okButtonProps={{ disabled: !name.trim() || name.trim() === workspace.name, loading: saving }}
      okText="Rename"
      onCancel={onClose}
      onOk={save}
      open={open}
      title="Rename workspace"
    >
      <label className="workspaces-field">
        Name
        <Input aria-label="Workspace name" maxLength={80} onChange={(event) => setName(event.target.value)} onPressEnter={save} value={name} />
      </label>
      {error && <p className="sbx-action-error" role="alert">{error}</p>}
    </Modal>
  );
}

RenameWorkspace.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSaved: PropTypes.func.isRequired,
  open: PropTypes.bool,
  workspace: PropTypes.object.isRequired,
};
